import { proxy } from 'valtio';

import { RequestError } from './requestError';
import { AppUser } from './user';

interface AppStore {
  appDrawer: {
    open: boolean;
    width: number;
  };
  appBar: {
    height: number;
  };
  contentHeight: number;
  requestErrors: RequestError[];
  hasRequestError: (id: string | null) => boolean;
  locale: string;
  currency: string;
  user: AppUser | null;
}

const appStore = proxy<AppStore>({
  appDrawer: {
    open: false,
    width: 240,
  },
  appBar: {
    height: 1,
  },
  get contentHeight() {
    return window.innerHeight - this.appBar.height;
  },
  requestErrors: [],
  hasRequestError(id: string | null) {
    return Boolean(
      this.requestErrors.find((err: RequestError) => err.id === id),
    );
  },
  get locale() {
    return this.user && this.user.locale ? this.user.locale : 'en-US';
  },
  get currency() {
    return this.user && this.user.currency ? this.user.currency : 'EUR';
  },
  user: null,
});

export { appStore };
export type { AppStore };
